import { getDirecte } from 'utils/canals';
import Player from 'components/3catinfo/Player';
import Players from 'components/3catinfo/Players';
import __isEmpty from 'lodash/isEmpty';
import __isUndefined from 'lodash/isUndefined';
import styles from './mediaDestacat.module.scss';

const MediaDestacatVideo = (props) => {
    const { idMedia } = props;
    return (
        <div className={styles.media} data-testid='noticia-media-video'>
            <div className={styles.video}>
                <Player id={idMedia} estils='noticia' playerVideoTagId={`media-principal-video-${idMedia}`} />
            </div>
        </div>
    );
};

const MediaDestacatAudio = (props) => {
    const { idMedia } = props;
    return (
        <div data-testid='noticia-media-audio' className={styles.media}>
            <div className={styles.audio}>
                <Players {...props} tipus='audioNoti' id={idMedia} playerVideoTagId={`media-principal-audio-${idMedia}`} />
            </div>
        </div>
    );
};

const MediaDestacat = (props) => {
    const { mediadestacats, audios, canalsDirectesEmbedats } = props;
    if (!__isEmpty(canalsDirectesEmbedats)) {
        const canalDirecte = getDirecte(canalsDirectesEmbedats);
        if (canalDirecte && canalDirecte?.tipus === 'audio') {
            return <MediaDestacatAudio idMedia={canalDirecte.canal} directe={true} autoPlay={false} />;
        } else {
            return <></>;
        }
    } else if (mediadestacats === 'AUDIO' && !__isEmpty(audios)) {
        return <MediaDestacatAudio idMedia={audios[0]?.id} autoPlay={true} {...props} />;
    } else {
        return <></>;
    }
};

export default MediaDestacat;
